import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Translation } from '../../common';

const Welcome = ({ className, styles }) => (
  <Translation
    isHtml
    className={classNames(styles['home-welcome__wrapper'], className)}
  >
    MAIN
  </Translation>
);

Welcome.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  styles: PropTypes.object,
};

export default Welcome;
